import Vue from 'vue';
Vue.component('calendar', () => import(/* webpackChunkName: "calendar" */ './Calendar'));
